import { widgetDefaultsFromFields } from "../widgetDefaultsFromFields";

export const LATEST_BLOGS_2_CONSTANTS = {
  LATEST_BLOGS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Main title",
      value: "Our {Latest Blogs}",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Wrap words in {} to highlight, e.g. Our {Latest Blogs}",
      required: false,
      defaultValue: "Our {Latest Blogs}",
    },
    {
      fieldName: "popular_section_title",
      label: "Popular blogs heading",
      value: "Popular {Blogs}",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Wrap words in {} to highlight, e.g. Popular {Blogs}",
      required: false,
      defaultValue: "Popular {Blogs}",
    },
    {
      fieldName: "new_blogs_section_title",
      label: "New blogs heading",
      value: "New Blogs",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Wrap words in {} to highlight, e.g. New {Blogs}",
      required: false,
      defaultValue: "New Blogs",
    },
    {
      fieldName: "new_blogs_hero_image",
      label: "New blogs hero image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Promo banner shown beside the New Blogs list",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "new_blogs_hero_subtitle",
      label: "New blogs hero subtitle",
      value: "Enrol Today!",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Enrol Today!",
      required: false,
      defaultValue: "Enrol Today!",
    },
    {
      fieldName: "new_blogs_hero_title",
      label: "New blogs hero title",
      value: "Book Your Seats Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Book Your Seats Now",
      required: false,
      defaultValue: "Book Your Seats Now",
    },
    {
      fieldName: "new_blogs_hero_url",
      label: "New blogs hero link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://… (optional CTA link)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "new_blogs_hero_alt",
      label: "New blogs hero alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "university_name",
      label: "University name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. IIT Kharagpur",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "university_logo",
      label: "University logo",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "University / institute logo",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "university_logo_alt",
      label: "University logo alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_text_color",
      label: "Title color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "section_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "read_more_label",
      label: "Read more label",
      value: "Read More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Read More",
      required: false,
      defaultValue: "Read More",
    },
    {
      fieldName: "read_more_text_color",
      label: "Read more color",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "nav_button_active_bg",
      label: "Carousel active button",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#BE2330",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "nav_button_inactive_bg",
      label: "Carousel inactive button",
      value: "#FECACA",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FECACA",
      required: false,
      defaultValue: "#FECACA",
    },
    {
      fieldName: "nav_icon_color",
      label: "Carousel icon color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "card_border_color",
      label: "Card border color",
      value: "#E0E0E0",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E0E0E0",
      required: false,
      defaultValue: "#E0E0E0",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable section",
      defaultValue: false,
    },
  ],
};

export const LATEST_BLOGS_2_WIDGET_DEFAULTS = {
  ...widgetDefaultsFromFields(
    LATEST_BLOGS_2_CONSTANTS.LATEST_BLOGS_FIELDS_CONFIG,
  ),
  metadata: [],
};
